import { ActionType, createAction, createReducer } from 'typesafe-actions';
import { PriceFormatConfigOptions } from '../products/types';
import { formatPrice } from '../../../common/formatting/formattingService';
import { get } from '../../../common/utils/objectUtils';
import { PDPApiAssemblyServiceProduct, PDPApiProductData, PDPAssemblyService } from './types';

export const addAssemblyService = createAction('@PRODUCT_DETAILS/ASSEMBLY/ADD', action => {
    return () => action();
});

export const removeAssemblyService = createAction('@PRODUCT_DETAILS/ASSEMBLY/REMOVE', action => {
    return () => action();
});

export type AssemblyServiceActionsType =
    | ActionType<typeof addAssemblyService>
    | ActionType<typeof removeAssemblyService>;

export const AssemblyServiceActions = [addAssemblyService, removeAssemblyService];

export const getAssemblyService = (
    pdpData: PDPApiProductData,
    formatOptions: PriceFormatConfigOptions
): PDPAssemblyService => {
    const [
        firstAssemblyService = {
            sku: '',
            name: '',
            price: {
                value: 0,
                currency: '',
            },
            size: '',
        },
    ]: PDPApiAssemblyServiceProduct[] = get(pdpData, 'assemblyServiceProducts', []);

    const { countryCode, currency } = formatOptions;
    const { price: rawPrice, name, sku } = firstAssemblyService;
    const price = formatPrice(countryCode, currency, rawPrice?.value);
    return {
        selected: false,
        price,
        name,
        sku,
    };
};

const assemblyServiceDefaultState = {
    price: '',
    sku: '',
    name: '',
    selected: false,
};
const assemblyServiceReducer = createReducer<PDPAssemblyService, AssemblyServiceActionsType>(
    assemblyServiceDefaultState
)
    .handleAction(addAssemblyService, state => ({ ...state, selected: true }))
    .handleAction(removeAssemblyService, state => ({ ...state, selected: false }));

export default assemblyServiceReducer;
